module.exports = __webpack_public_path__ + "img/04.0b886559.jpg";